import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const updateOne = (_, { payload: { id: questionId } }) => questionId;

export default createReducer(initialState, {
  [types.FETCH_DEFAULT_QUESTION_MODEL_SUCCESS]: updateOne,
});
